import React, { Component } from "react";
import Routes from "./Routes";
import "react-notifications/lib/notifications.css";
import "./scss/index.css";
class App extends Component {
  render = () => <Routes />;
}
export default App;
